<template>
    <b-row>
        <b-col>
            <b-row class="mb-3">
                <div class="dropbox">
                    <input :disabled="uploading" @change="onFilesChanged($event.target.files)" class="input-file" id="files" type="file" multiple ref="files">
                    <md-icon v-if="uploading">add</md-icon>

                    <div v-else class="dropbox-desc">
                        <p>Add Files <i class="el-icon-plus add-icon"></i></p>
                        <i>Drag your files here or click</i>
                    </div>
                </div>
            </b-row>
            <md-chip color="#2C8C87" text-color="white" v-for="(file) in value" :key="file.name">{{ file.name }}</md-chip>

            <b-row v-if="uploading" row class="mt-5">
              <md-progress-spinner  :md-diameter="30" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
            </b-row>
            <b-row v-else row class="mt-5">
                <md-button class="play-cta-button-flat grey" @click="clearFiles" :disabled="!value.length || uploading">Clear</md-button>
                <md-button class="play-cta-button navy" @click="uploadFiles" :disabled="!value.length">Upload</md-button>
            </b-row>
        </b-col>

        <md-snackbar :md-active.sync="showSnackbar" md-persistent>
            <span>{{ snackbarText }}</span>
        </md-snackbar>

    </b-row>
</template>

<script>
  import { allowedFileMimeType } from '../../platform/files/services/fileService';

  const MAX_FILE_MB = 2;

  export default {
    props: {
      value: {
          type: Array | FileList,
          default: () => [],
      },
      uploading: {
          type: Boolean,
          default: false,
      },
      allowedMimeTypes: {
          type: Array,
          default: () => [],
      },
      disableMimeTypeCheck: {
          type: Boolean,
          default: false,
      },
      maxFileSizeMb: {
          type: Number,
          default: MAX_FILE_MB,
      },
    },
    data() {
      return {
        showSnackbar: false,
        snackbarText:"",
      };
    },
    methods: {
        clearFiles() {
            this.$refs.files.value = '';

            this.$emit('input', []);
        },
        removeFile(index) {
            const result = Array.from(this.value);
            result.splice(index, 1);

            this.$emit('input', result);
        },
        filesAreAllowed(files) {
          for (const file of files) {
              let validationResult = this.allowedMime(file);
              if (!validationResult.success) {
                  return { success: false, message: validationResult.message };
              }
              validationResult = this.allowedSize(file);
              if (!validationResult.success) {
                  return { success: false, message: validationResult.message };
              }
          }

          return { success: true, message: '' };
        },
      allowedSize(file) {
        if (file.size / 1000000 > this.maxFileSizeMb) {
            return { success: false, message: "File too large, " + "max " + MAX_FILE_MB + "Mb allowed" };
        }

        return { success: true, message: "" };
      },
      allowedMime(file) {
        if (this.disableMimeTypeCheck) {
            return { success: true, message: "" };
        }
        if (this.allowedMimeTypes.length && this.allowedMimeTypes.indexOf(file.type) >= 0) {
            return { success: true, message: "" };
        }
        if (allowedFileMimeType(file)) {
            return { success: true, message: "" };
        }

        return { success: false, message: "File type not allowed" };
      },
      onFilesChanged(files) {
        try {
            const validationResult = this.filesAreAllowed(files);
            if (!validationResult.success) {
                this.notifyUser(validationResult.message);
            }

            this.$emit('input', files);
        }
        catch (error) {
            console.error(error);
        }
      },
      notifyUser(message) {
          this.showSnackbar = true;
          this.snackbarText = message;
      },
      uploadFiles() {
          this.$emit('upload', this.value);
      },
    }
  }
</script>
<style scoped>
  @import '../../assets/styles/global.css';

 .add-icon{
    color: #506993;
    text-align: center;
  }

  .dropbox {
    outline: 2px dashed grey;
    color: dimgray;
    display: table;
    width: 100%;
    position: relative;
  }
  .image-preview-container{
    background-color: #eaeaea80;
  }

  .dropbox-desc{
    vertical-align: middle;
    display: table-cell;
    text-align: center;
    height: 100%;
    padding: 1em;
  }
  .dropbox-desc p{
    margin-bottom:0;
  }

  .input-file {
    opacity: 0; /* invisible but it's there! */
    position: absolute;
    cursor: pointer;
    width: 100%;
    height: 100%;
  }

  .dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 0;
  }
  .img-working-cover{
    width: 100%;
    height: 100%;
    position: absolute;
    color: grey;
    background-color: rgb(0,0,0,0.6);
    color: white;
    text-align: center;
    padding-top: 60px;
  }
  .show-when-parent-hover {
    opacity: 0;
    position: absolute;
    cursor: pointer;
    width: 55px;
    height: 55px;
    top: 25%;
    left: 38%;
  }

  .image-preview-container:hover .show-when-parent-hover{
    opacity: 1;
  }

  .image-preview-container:hover .photo-add-holder{
    opacity: 0.2
  }
  .img-upload-progress-bar{
  	height: 10%;
  	font-size: 0.75rem;
  	background-color: #e9ecef;
  	margin-left: 1em;
  	margin-right: 1em;
  	position: relative;
  	top: 45%;
  }



  .photo-add-holder {
    cursor: pointer;
  }

  .photo-add-holder li.el-upload-list{
    min-width: 244px;
    min-height: 156px;
  }

  .photo-uploded{
    padding: 15px;
  }
  #skip-add-img-btn{
    width: 100%;
    background: lightgrey;
    border:none;
  }
</style>



// WEBPACK FOOTER //
// src/components/files/FilesSelector.vue